import { useState } from 'react';
import GeneralDialog from '../../../../shared/general-dialog';
import { parsePastedOptions } from './label-draft-mapper';
import { DIALOG_CANCEL_BUTTON_SX } from './label-schema';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface PasteOptionsDialogProps {
  open: boolean;
  handleClose: () => void;
  onAdd: (names: string[]) => void;
}

export default function PasteOptionsDialog({
  open,
  handleClose,
  onAdd,
}: PasteOptionsDialogProps) {
  const [content, setContent] = useState('');
  const names = parsePastedOptions(content);

  const close = () => {
    setContent('');
    handleClose();
  };

  return (
    <GeneralDialog
      open={open}
      handleClose={close}
      title="Paste multiple"
      maxWidth="sm"
      dialogContent={
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography variant="body2">
            Paste multiple content (e.g. from a spreadsheet) to create multiple
            options for this field
          </Typography>
          <TextField
            id="paste-options-content"
            label="Content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
            fullWidth
            autoFocus
          />
        </Stack>
      }
      primaryButton={{
        title: 'Add Options',
        action: () => {
          onAdd(names);
          close();
        },
        loading: false,
        disabled: names.length === 0,
      }}
      secondaryButton={{
        title: 'Cancel',
        action: close,
        loading: false,
        disabled: false,
        // GeneralDialog hides the secondary button unless it's marked shown; the design has Cancel.
        shown: true,
        sx: DIALOG_CANCEL_BUTTON_SX,
      }}
    />
  );
}
